import { createContext } from 'react';

const PaginationOffsetContext = createContext();

export const { Provider, Consumer } = PaginationOffsetContext;

export default PaginationOffsetContext;
